import { put } from 'redux-saga/effects';
import OpenDoorActions from '../redux/OpenDoorRedux';
import i18n from '../i18n';

export function* openDoor(api, { controllerId, customerId }) {
  try {
    const openDoorResponse = yield api.openDoor(controllerId, customerId);
    console.log('openDoorResponse:', openDoorResponse);
    if (openDoorResponse.ok) {
      yield put(OpenDoorActions.openDoorRequestSuccess(openDoorResponse.data));
    } else {
      api.checkAuth(openDoorResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof openDoorResponse.problem !== 'undefined'
          ? openDoorResponse.problem
          : typeof openDoorResponse.data.error !== 'undefined'
          ? openDoorResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(OpenDoorActions.openDoorRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(OpenDoorActions.openDoorRequestFailure(error));
  }
}

export function* checkDoorStatus(api, { controllerId, commandId }) {
  try {
    const checkDoorStatusResponse = yield api.checkDoorStatus(controllerId, commandId);
    console.log('checkDoorStatusResponse:', checkDoorStatusResponse);
    const successMessage = i18n.t('successMessage.checkDoorStatusSuccess');
    if (checkDoorStatusResponse.ok) {
      const isDoorOpening = checkDoorStatusResponse.status !== 202;
      yield put(
        OpenDoorActions.checkDoorStatusRequestSuccess(successMessage, checkDoorStatusResponse.status, isDoorOpening)
      );
    } else {
      api.checkAuth(checkDoorStatusResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof checkDoorStatusResponse.problem !== 'undefined'
          ? checkDoorStatusResponse.problem
          : typeof checkDoorStatusResponse.data.error !== 'undefined'
          ? checkDoorStatusResponse.data.error
          : null;
      if (errorBody) {
        let translatedError = i18n.t(`error.${errorBody}`);
        if (errorBody === 'CLIENT_ERROR') {
          translatedError = i18n.t('unexpectedError');
        }
        error += `: ${translatedError}`;
      }
      yield put(OpenDoorActions.checkDoorStatusRequestFailure(error, checkDoorStatusResponse.status));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(OpenDoorActions.checkDoorStatusRequestFailure(error, 500));
  }
}
